import React from 'react';
import {
    SiCodechef,
    SiCodeforces,
    SiLinkedin,
    SiTwitter,
    SiGithub,
    SiInstagram,
} from 'react-icons/si';
import { FaKaggle } from 'react-icons/fa';
import { IconContext } from 'react-icons';

const Contact = () => {
    const links = [
        {
            icon: <SiCodechef />,
            link: 'https://www.codechef.com/users/utsavk02',
        },
        {
            icon: <SiCodeforces />,
            link: 'https://codeforces.com/profile/Utsavk02',
        },
        {
            icon: <FaKaggle />,
            link: 'https://www.kaggle.com/utsavk02',
        },
        {
            icon: <SiLinkedin />,
            link: 'https://www.linkedin.com/in/utsavkhatu/',
        },
        {
            icon: <SiTwitter />,
            link: 'https://twitter.com/UtsavKhatu',
        },
        {
            icon: <SiGithub />,
            link: 'https://github.com/utsavk28',
        },
        {
            icon: <SiInstagram />,
            link: 'https://www.instagram.com/utsavk02/',
        },
    ];
    return (
        <div className='text-white'>
            <div className='flex flex-wrap place-content-around backdrop-blur bg-white/20 w-full mt-16 bottom-0 p-2 py-4'>
                <div className='my-2'>
                    <p>Copyright 2022. All rights reserved.</p>
                </div>
                <div className='my-2'>
                    <p className='text-center'>
                        Designed and Developed With ❤ by Utsav Khatu
                    </p>
                </div>
                <div className='flex flex-wrap place-content-center'>
                    {links.map((link, idx) => {
                        return (
                            <div key={idx} className='m-1'>
                                <a href={link.link}>
                                    <IconContext.Provider
                                        value={{
                                            color: 'silver',
                                            className: 'my-auto w-6 h-6 ',
                                        }}
                                    >
                                        {link.icon}
                                    </IconContext.Provider>
                                </a>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default Contact;
